import React from "react";
import styled from "styled-components";
import Slider from "react-slick";

import Contain from "../contain";
import Title from "../title";
import Video from "../video";

const Testimonial = styled.section`
  padding: 5rem 0;
`;

const Description = styled.div`
  max-width: 40rem;
  margin: 0 auto;
  font-size: 1.1rem;
  font-weight: 500;
  text-align: center;
  line-height: 1.6;
`;

const Reviews = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem 0;
  margin: 0 auto;

  @media (max-width: 50rem) {
    flex-direction: column;
  }
`;

const ReviewContain = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 0 1rem;
  flex-direction: column;

  @media (max-width: 50rem) {
    margin-bottom: 2rem;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

const ReviewLink = styled.a`
  flex: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #ebf8ff;
  border-radius: 50rem;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  text-transform: uppercase;
  color: #4a5568;
  font-weight: 600;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  > svg {
    margin-right: 0.5rem;
  }
`;

const ReviewInfo = styled.div`
  padding: 1rem 0 0;
`;

const Score = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;

  span {
    font-size: 2rem;
    color: 4a5568;
    font-weight: 600;
    padding-right: 0.5rem;
  }
`;

const Info = styled.div`
  fonst-size: 1rem;
  color: #718096;
  padding-top: 0.1rem;
  font-weight: 500;
`;

const SliderItem = styled.div`
  padding: 0 1rem 2rem;
`;

const Meta = styled.div`
  text-align: center;
  padding: 1rem 0 0;
`;

const Name = styled.div`
  font-size: 1.2rem;
  margin: 0 0 0.2rem;
  font-weight: 600;
`;

const Company = styled.div`
  color: #718096;
  font-weight: 500;
  font-size: 0.8rem;
`;

const ReviewInfoComponent = ({ score, numbers }) => (
  <ReviewInfo>
    <Score>
      <span>{score}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="96"
        height="16"
        fill="none"
      >
        <g clipPath="url(#clip0)">
          <path
            fill="#FFC107"
            d="M15.575 5.723l-4.918-.752L8.452.275c-.165-.35-.74-.35-.905 0L5.343 4.971l-4.918.752a.5.5 0 00-.282.843l3.573 3.663-.845 5.178a.5.5 0 00.736.518L8 13.495l4.393 2.43a.5.5 0 00.736-.519l-.845-5.178 3.573-3.662a.5.5 0 00-.282-.844z"
          ></path>
        </g>
        <g clipPath="url(#clip1)">
          <path
            fill="#FFC107"
            d="M35.575 5.723l-4.918-.752L28.452.275c-.165-.35-.74-.35-.905 0l-2.204 4.696-4.918.752a.5.5 0 00-.282.843l3.573 3.663-.845 5.178a.5.5 0 00.736.518L28 13.495l4.393 2.43a.5.5 0 00.736-.519l-.845-5.178 3.573-3.662a.5.5 0 00-.282-.844z"
          ></path>
        </g>
        <g clipPath="url(#clip2)">
          <path
            fill="#FFC107"
            d="M55.575 5.723l-4.918-.752L48.452.275c-.165-.35-.74-.35-.905 0l-2.204 4.696-4.918.752a.5.5 0 00-.282.843l3.573 3.663-.845 5.178a.5.5 0 00.736.518L48 13.495l4.393 2.43a.5.5 0 00.736-.519l-.845-5.178 3.573-3.662a.5.5 0 00-.282-.844z"
          ></path>
        </g>
        <g clipPath="url(#clip3)">
          <path
            fill="#FFC107"
            d="M75.575 5.723l-4.918-.752L68.452.275c-.165-.35-.74-.35-.905 0l-2.204 4.696-4.918.752a.5.5 0 00-.282.843l3.573 3.663-.845 5.178a.5.5 0 00.736.518L68 13.495l4.393 2.43a.5.5 0 00.736-.519l-.845-5.178 3.573-3.662a.5.5 0 00-.282-.844z"
          ></path>
        </g>
        <g clipPath="url(#clip4)">
          <path
            fill="#FFC107"
            d="M95.575 5.723l-4.918-.752L88.452.275c-.165-.35-.74-.35-.905 0l-2.204 4.696-4.918.752a.5.5 0 00-.282.843l3.573 3.663-.845 5.178a.5.5 0 00.736.518L88 13.495l4.393 2.43a.5.5 0 00.736-.519l-.845-5.178 3.573-3.662a.5.5 0 00-.282-.844z"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0">
            <path fill="#fff" d="M0 0h16v16H0z"></path>
          </clipPath>
          <clipPath id="clip1">
            <path
              fill="#fff"
              d="M0 0h16v16H0z"
              transform="translate(20)"
            ></path>
          </clipPath>
          <clipPath id="clip2">
            <path
              fill="#fff"
              d="M0 0h16v16H0z"
              transform="translate(40)"
            ></path>
          </clipPath>
          <clipPath id="clip3">
            <path
              fill="#fff"
              d="M0 0h16v16H0z"
              transform="translate(60)"
            ></path>
          </clipPath>
          <clipPath id="clip4">
            <path
              fill="#fff"
              d="M0 0h16v16H0z"
              transform="translate(80)"
            ></path>
          </clipPath>
        </defs>
      </svg>
    </Score>
    <Info>{numbers} Reviews</Info>
  </ReviewInfo>
);

export default class Testimonials extends React.Component {
  state = {
    width: null
  };

  componentDidMount() {
    this.setState({ width: window.innerWidth });
  }

  render() {
    const { title, description } = this.props;
    const { width } = this.state;
    const mobile = width < 680;
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: mobile ? 1 : 3,
      slidesToScroll: mobile ? 1 : 3
    };

    return (
      <Testimonial>
        <Contain>
          <Title textCenter>{title}</Title>
          <Description>{description}</Description>
          <Reviews>
            <ReviewContain>
              <ReviewLink
                href="https://itunes.apple.com/us/app/quickpage-app/id1087963048?mt=8"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  fill="none"
                >
                  <path
                    fill="#1076F7"
                    d="M36.209 29.378c-.108.304-.212.63-.332.95-.993 2.69-2.501 5.078-4.331 7.267a9.364 9.364 0 01-1.19 1.17c-.84.71-1.806 1.14-2.924 1.179a5.862 5.862 0 01-2.423-.442c-.563-.23-1.117-.486-1.687-.694-1.852-.673-3.694-.584-5.517.136-.657.26-1.305.547-1.974.772-.776.26-1.58.366-2.4.211-.716-.133-1.341-.466-1.922-.896-.721-.533-1.327-1.184-1.893-1.872-2.68-3.27-4.48-6.966-5.349-11.107-.374-1.78-.554-3.575-.444-5.395.129-2.182.636-4.26 1.802-6.132 1.463-2.353 3.527-3.895 6.243-4.53 1.633-.385 3.222-.228 4.78.372.819.314 1.64.624 2.464.932a3.098 3.098 0 002.271-.005c.84-.32 1.68-.64 2.524-.953.864-.315 1.744-.573 2.66-.646a9.993 9.993 0 014.015.503c1.846.618 3.349 1.711 4.483 3.303l.087.127c-2.862 1.995-4.49 4.63-4.254 8.197.239 3.57 2.16 5.985 5.31 7.553zM20.159 9.253a6.108 6.108 0 002.437-.45c3.565-1.415 5.428-5.186 5.372-8.07-.004-.232-.02-.464-.03-.733-.367.055-.7.08-1.022.161-2.602.638-4.604 2.09-5.92 4.442-.77 1.376-1.2 2.838-1.068 4.436.009.17.07.212.23.214z"
                  ></path>
                </svg>
                App Store
              </ReviewLink>
              <ReviewInfoComponent score="4.9" numbers="49" />
            </ReviewContain>

            <ReviewContain>
              <ReviewLink
                href="https://play.google.com/store/apps/details?id=quickpage.app.com&hl=en"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  fill="none"
                >
                  <g fill="#A4C639" clipPath="url(#clipa0)">
                    <path d="M30.146 13.206H9.854a.817.817 0 00-.817.817V31.04c0 .451.366.817.817.817h3.618v5.735a2.41 2.41 0 104.818 0v-5.735h3.37v5.735a2.41 2.41 0 104.818 0v-5.735h3.668a.817.817 0 00.817-.817V14.023a.817.817 0 00-.817-.817zm-24.544-.004a2.41 2.41 0 00-2.41 2.41v9.784a2.41 2.41 0 004.819 0v-9.785a2.41 2.41 0 00-2.41-2.41zm28.796 0a2.41 2.41 0 00-2.409 2.41v9.784a2.41 2.41 0 104.819 0v-9.785a2.41 2.41 0 00-2.41-2.41zm-24.38-1.19h19.915c.52 0 .907-.478.8-.987a11.008 11.008 0 00-5.37-7.314L27.067.64a.43.43 0 00-.753-.417l-1.715 3.095a10.95 10.95 0 00-4.622-1.016 10.95 10.95 0 00-4.622 1.016L13.64.222a.43.43 0 00-.753.417l1.702 3.072a11.008 11.008 0 00-5.37 7.314.818.818 0 00.8.987zm15.9-4.578a.926.926 0 11-1.852 0 .926.926 0 011.852 0zM14.96 6.508a.926.926 0 110 1.853.926.926 0 010-1.853z"></path>
                  </g>
                  <defs>
                    <clipPath id="clipa0">
                      <path fill="#fff" d="M0 0h40v40H0z"></path>
                    </clipPath>
                  </defs>
                </svg>
                PLAY STORE
              </ReviewLink>
              <ReviewInfoComponent score="4.9" numbers="56" />
            </ReviewContain>

            <ReviewContain>
              <ReviewLink
                href="https://facebook.com/quickpageapp"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  fill="none"
                >
                  <path
                    fill="#1977F3"
                    d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M25.028 20.783h-3.569v13.074h-5.407V20.783H13.48v-4.595h2.572v-2.973c0-2.126 1.01-5.456 5.455-5.456l4.005.017v4.46h-2.906c-.476 0-1.147.238-1.147 1.252v2.704H25.5l-.472 4.591z"
                  ></path>
                </svg>
                Facebook
              </ReviewLink>
              <ReviewInfoComponent score="5.0" numbers="57" />
            </ReviewContain>
          </Reviews>

          <Slider {...settings}>
            <SliderItem>
              <Video
                url="https://dburs8kx36lyd.cloudfront.net/media/906D45B3-4617-404E-C377-0DF6AC8C72AE/z9mPZaxM7saqjzgyx.mp4-web.mp4"
                poster="https://dburs8kx36lyd.cloudfront.net/media/906D45B3-4617-404E-C377-0DF6AC8C72AE/z9mPZaxM7saqjzgyx.mp4-poster-00001.png"
                autoplay={true}
              />
              <Meta>
                <Name>Jean Richer</Name>
                <Company>Keller Williams Integrity Realty</Company>
              </Meta>
            </SliderItem>

            <SliderItem>
              <Video
                url="https://dburs8kx36lyd.cloudfront.net/media/EC2A8E2D-2CDF-4456-8A45-F0368E3DFE12/uwNpTEu2d8TNEpDPE.mp4-web.mp4"
                poster="https://dburs8kx36lyd.cloudfront.net/media/2A7806D5-F50E-428E-A282-4DFA80B0FCAA/cjRn3rCpxxy4HdrNx.png"
                autoplay={true}
              />
              <Meta>
                <Name>Shannon Unger</Name>
                <Company>RE/MAX Legend</Company>
              </Meta>
            </SliderItem>

            <SliderItem>
              <Video
                url="https://dburs8kx36lyd.cloudfront.net/media/BA58F6EE-4E7A-4B0B-BA4E-B1D8791F5D9C/NKzCewz9AdsEyCjkX.mp4-web.mp4"
                poster="https://dburs8kx36lyd.cloudfront.net/media/BA58F6EE-4E7A-4B0B-BA4E-B1D8791F5D9C/NKzCewz9AdsEyCjkX.mp4-poster-00001.png"
                autoplay={true}
              />
              <Meta>
                <Name>Jason Steele</Name>
                <Company>Royal Lepage Exchange Realty</Company>
              </Meta>
            </SliderItem>
          </Slider>
        </Contain>
      </Testimonial>
    );
  }
}
